import {
  Message
} from 'element-ui';
let messageInstance = null;
const resetMessage = (options) => {
    if(messageInstance) {
        messageInstance.close()
    }
    messageInstance = Message(options)
};
['error','success','info','warning'].forEach(type => {
    resetMessage[type] = options => {
        if(typeof options === 'string') {
            options = {
                message:options
            }
        }
        options.type = type
        return resetMessage(options)
    }
})
 const resmessage = resetMessage
export default{
    methods: {
        success(command){
          let message = {
            add: '新增成功',
            upd: '修改成功',
            inq: '查询成功',
            del: '删除成功',
            load: '上传成功',
            save: '保存成功',
            submit: '提交成功',
          }
          resmessage.success(command && message[command] || '操作成功')
          return true
        },
        faild(command){
            let message = {
              add: '新增失败',
              upd: '修改失败',
              inq: '查询失败',
              del: '删除失败',
              load: '上传失败',
              loadImg: '上传图片失败',
              emptyKeyWord: '请输入关键字',
              save: '保存失败',
              submit: '提交失败',
            }
           resmessage.error(command && message[command] || '操作失败')
            return true
          },
          warning(command,msg){
            let message = {
                diy:msg
              }
             resmessage.warning(command && message[command] || '操作警告')
              return true
          }
    }
}